import { ViewBooking } from "collins-js-sdk";
import React from "react";
import { useDiaryContext } from "../../../../../hooks/useDiaryContext";
import { BookableArea } from "../../../../../types/venues";
import {
  getAlreadyJoinAssignedAreaList,
  getEndTime
} from "../../../../../utils/booking";
import UserIcon from "../../../../../assets/icons/icon-user.png";

type SelectedAreaMessageType = {
  booking: ViewBooking;
  selectedAreas: BookableArea[];
  waitlistSlotMins: number;
};

const SelectedAreaMessage = ({
  booking,
  selectedAreas,
  waitlistSlotMins
}: SelectedAreaMessageType) => {
  const bookingContext = useDiaryContext();
  const { venueConfig } = bookingContext;

  if (selectedAreas.length === 0 && !booking.waitlisted) {
    return null;
  }

  const alreadyAssignedAreaList = getAlreadyJoinAssignedAreaList(
    selectedAreas,
    booking,
    bookingContext?.bookings
  );

  const assignTableName = selectedAreas?.map((bookingArea: BookableArea) => {
    return bookingArea.name;
  });

  const assignZoneName = selectedAreas
    ? [
        ...new Set(
          selectedAreas.map((bookingArea: BookableArea) => bookingArea.zone)
        )
      ]
    : [];

  const minCapacity = selectedAreas.reduce(
    (count, area) => (area.min_people ?? 0) + count,
    0
  );

  const maxCapacity = selectedAreas.reduce(
    (count, area) => (area.max_people_seated ?? 0) + count,
    0
  );

  if (booking.waitlisted && waitlistSlotMins > 0) {
    return (
      <div className="-mt-2 pb-3 [[data-theme='Light']_&]:mt-2.5">
        {booking.waitlisted && waitlistSlotMins > 0 && (
          <span>{`Added to waitlist (Est. ${waitlistSlotMins} Minutes)`}</span>
        )}
      </div>
    );
  }

  return (
    <div className="-mt-2 pb-3 [[data-theme='Light']_&]:mt-2.5">
      {alreadyAssignedAreaList && alreadyAssignedAreaList?.length > 0 ? (
        <div>
          {` This area is already occupied from ${
            alreadyAssignedAreaList?.[0]?.time
          } until ${getEndTime(alreadyAssignedAreaList[0], venueConfig ?? undefined)}`}
        </div>
      ) : null}
      {booking.numPeople &&
      booking.numPeople > maxCapacity &&
      selectedAreas.length > 0 ? (
        <p>{"table / area is no longer available."}</p>
      ) : null}
      <div className="flex items-baseline justify-between font-[var(--fontStyle)] text-left">
        <div>
          <p className="text-[11px] font-bold text-[var(--primaryColor)] capitalize pb-1.5 w-[225px] [[data-theme='Light']_&]:text-[13px]">
            {assignTableName.length > 1
              ? assignTableName &&
                assignTableName
                  .slice(0, -1)
                  .join(", ")
                  .concat(" & ", assignTableName.slice(-1).toString())
              : assignTableName}
          </p>
          <p>
            {assignZoneName.length > 1
              ? assignZoneName &&
                assignZoneName
                  .slice(0, -1)
                  .join(", ")
                  .concat(" & ", assignZoneName.slice(-1).toString())
              : assignZoneName}
          </p>
        </div>
        <div className="flex">
          <img src={UserIcon} className="h-3 mr-1.5" alt="icon-user" />
          &nbsp;
          <span className="text-[11px] font-bold">
            {`${minCapacity} - ${maxCapacity}`}
          </span>
        </div>
      </div>
    </div>
  );
};

export default React.memo<SelectedAreaMessageType>(SelectedAreaMessage);
